<template lang="pug">
.absolute.loading.z-100.w-full.h-full.flex.justify-center
  .load-bg.absolute
  .loader.loader--style2.absolute()
    .flex.items-center.justify-center.bg-white.w-200.h-200.rounded-16
      div
        .flex.justify-center
          svg.w-56.h-56.mb-25(version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve")
            defs
              linearGradient#linear(x1="0" y1="0" x2="100%" y2="100%"  )
                //-gradientUnits="userSpaceOnUse"
                stop(stop-color="#0051a8" offset="0")
                stop(stop-color="#83d5ff" offset="100%")
            path(  d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z")
              
              animateTransform(attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite")
        .text-center  {{$t('__popUpRelated.__loading')}}
        .text-center  {{$t('__popUpRelated.__pleaseWait')}}

  //- iCon.h-80.w-80.inline-block.relative(iconClass="ico-processing" type="svg" class="top-304" :animate="true")
  //- img.w-80.h-80.inline-block.relative(src='@/assets/loading2.gif' class="top-304")
</template>

<script>
export default {
  name: "Loading",
  data() {//loading
    return {};
  }
};
</script>

<style lang="scss" scoped>



.loading{
  @apply  fixed top-0 right-0 bottom-0 left-0 bg-modal;
  .load-bg{
    content: '';
    z-index: 0;
    width:100%;
    height: 100%;
    background-color: #838487;
    opacity: 0.5;
  }
  .loader{
    transform: translate(-50%, -50%);
    top:50%;
    left:50%;
    svg{
      // color: tomato;
    }
    path{
      fill: url(#linear);
    }
  }
}



</style>
